import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, isRef as _isRef } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = {
  class: "position-relative",
  style: {"min-width":"220px","max-width":"300px","flex":"1 1 auto"}
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_27 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_28 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_30 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_31 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_33 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_34 = { class: "dropdown-menu" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  class: "",
  type: "button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#offcanvasExample",
  "aria-controls": "offcanvasExample"
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "card-footer" }
const _hoisted_47 = {
  key: 0,
  class: "pagination-area d-md-flex mt-3 mb-0 justify-content-between align-items-center"
}
const _hoisted_48 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_49 = { class: "fw-bold" }
const _hoisted_50 = { class: "fw-bold" }
const _hoisted_51 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_52 = { class: "fw-bold" }
const _hoisted_53 = { class: "fw-bold" }
const _hoisted_54 = { class: "mt-15 mt-md-0" }
const _hoisted_55 = { class: "pagination flex-nowrap mb-0" }
const _hoisted_56 = {
  key: 0,
  class: "page-item"
}
const _hoisted_57 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_58 = ["onClick"]
const _hoisted_59 = {
  key: 1,
  class: "page-item"
}
const _hoisted_60 = {
  class: "offcanvas offcanvas-end permission-offcanvas",
  tabindex: "-1",
  id: "offcanvasExample",
  "aria-labelledby": "offcanvasExampleLabel"
}
const _hoisted_61 = { class: "offcanvas-header border-bottom" }
const _hoisted_62 = {
  class: "offcanvas-title",
  id: "offcanvasExampleLabel"
}
const _hoisted_63 = { class: "offcanvas-body" }
const _hoisted_64 = { class: "nav nav-pills gap-2 flex-nowrap overflow-auto text-nowrap mb-20 pb-5" }
const _hoisted_65 = { class: "nav-item" }
const _hoisted_66 = { class: "nav-item" }
const _hoisted_67 = { class: "nav-item" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = {
  key: 0,
  class: "text-muted text-center py-30"
}
const _hoisted_70 = { class: "min-w-0" }
const _hoisted_71 = { class: "fw-semibold text-black text-truncate" }
const _hoisted_72 = { class: "fs-12 text-body-tertiary text-truncate" }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { key: 1 }
const _hoisted_75 = {
  key: 0,
  class: "mb-15"
}
const _hoisted_76 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_77 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_78 = {
  key: 1,
  class: "mb-15"
}
const _hoisted_79 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_80 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_81 = {
  class: "row g-2 mb-15 flex-grow-1",
  style: {"align-content":"flex-start"}
}
const _hoisted_82 = ["id", "value", "disabled"]
const _hoisted_83 = ["for"]
const _hoisted_84 = ["disabled"]
const _hoisted_85 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_86 = {
  key: 1,
  class: "flaticon-plus position-relative ms-5 fs-12",
  style: {"color":"#FFF"}
}
const _hoisted_87 = { key: 2 }
const _hoisted_88 = {
  key: 0,
  class: "text-muted text-center py-30"
}
const _hoisted_89 = { class: "min-w-0" }
const _hoisted_90 = { class: "fw-semibold text-black text-truncate" }
const _hoisted_91 = { class: "fs-12 text-body-tertiary text-truncate" }
const _hoisted_92 = ["onClick"]
const _hoisted_93 = {
  class: "modal fade",
  id: "revokePermissionModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_94 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_95 = { class: "modal-content" }
const _hoisted_96 = { class: "modal-header" }
const _hoisted_97 = { class: "modal-title fs-5" }
const _hoisted_98 = { class: "modal-body" }
const _hoisted_99 = { class: "fw-semibold text-black mb-15" }
const _hoisted_100 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_101 = ["placeholder"]
const _hoisted_102 = {
  key: 0,
  class: "text-red fw-bold mt-10 text-center",
  style: {"color":"red"}
}
const _hoisted_103 = { class: "modal-footer" }
const _hoisted_104 = {
  type: "button",
  class: "btn btn-outline-dark",
  "data-bs-dismiss": "modal"
}
const _hoisted_105 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_106 = { class: "modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down" }
const _hoisted_107 = { class: "modal-content" }
const _hoisted_108 = { class: "modal-header" }
const _hoisted_109 = { class: "modal-title fs-5" }
const _hoisted_110 = { class: "modal-body" }
const _hoisted_111 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_112 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_113 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_114 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_115 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_116 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_117 = { class: "row g-3" }
const _hoisted_118 = { class: "col-12 col-md-6" }
const _hoisted_119 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_120 = ["placeholder", "readonly"]
const _hoisted_121 = { class: "invalid-feedback" }
const _hoisted_122 = { class: "col-12 col-md-6" }
const _hoisted_123 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_124 = ["placeholder", "readonly"]
const _hoisted_125 = { class: "invalid-feedback" }
const _hoisted_126 = { class: "row g-3 mt-1" }
const _hoisted_127 = { class: "col-6 col-md-3" }
const _hoisted_128 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_129 = ["disabled"]
const _hoisted_130 = { value: "" }
const _hoisted_131 = { class: "col-6 col-md-3" }
const _hoisted_132 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_133 = ["disabled"]
const _hoisted_134 = { value: "" }
const _hoisted_135 = ["value"]
const _hoisted_136 = { class: "col-12 col-md-6" }
const _hoisted_137 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_138 = { value: "INACTIVE" }
const _hoisted_139 = { value: "ACTIVE" }
const _hoisted_140 = {
  key: 0,
  class: "row g-3 mt-1",
  id: "web"
}
const _hoisted_141 = { class: "col-12 col-md-6" }
const _hoisted_142 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_143 = { class: "invalid-feedback" }
const _hoisted_144 = { class: "col-12 col-md-6" }
const _hoisted_145 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_146 = { class: "invalid-feedback" }
const _hoisted_147 = {
  key: 1,
  class: "row g-3 mt-1 align-items-end",
  id: "api"
}
const _hoisted_148 = {
  key: 0,
  class: "col-9 col-md-11"
}
const _hoisted_149 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_150 = { class: "row form-control shadow-none d-flex flex-row align-items-center mx-0" }
const _hoisted_151 = {
  class: "col-auto ps-0",
  id: "password-hidden"
}
const _hoisted_152 = {
  key: 1,
  class: "col-3 col-md-1"
}
const _hoisted_153 = { class: "modal-footer" }
const _hoisted_154 = {
  key: 0,
  type: "submit",
  class: "btn text-white w-100 w-sm-auto",
  style: {"background-color":"#EB9355"}
}
const _hoisted_155 = {
  class: "modal fade",
  id: "staticBackdrop",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_156 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_157 = { class: "modal-content" }
const _hoisted_158 = { class: "modal-body text-center" }
const _hoisted_159 = { class: "text-black fw-bold mb-0 text-center" }
const _hoisted_160 = { class: "modal-footer text-center" }
const _hoisted_161 = {
  type: "button",
  class: "btn btn-outline-dark",
  "data-bs-dismiss": "modal"
}
const _hoisted_162 = {
  class: "modal fade",
  id: "generatePasswordModal",
  tabindex: "-1",
  "aria-labelledby": "generatePasswordModalLabel",
  "aria-hidden": "true"
}
const _hoisted_163 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_164 = { class: "modal-content" }
const _hoisted_165 = { class: "modal-header" }
const _hoisted_166 = {
  class: "modal-title fs-5",
  id: "generatePasswordModalLabel"
}
const _hoisted_167 = { class: "modal-body" }
const _hoisted_168 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_169 = { class: "row form-control shadow-none d-flex flex-row align-items-center mx-0" }
const _hoisted_170 = {
  class: "col-auto ps-0",
  id: "password-hidden-generated"
}
const _hoisted_171 = { class: "modal-footer" }

import { ref, onMounted, reactive, inject, computed, watch } from "vue";
import axios from 'axios';
import flatpickr from "flatpickr";
import { Modal } from "bootstrap";
import { useRoute, useRouter } from 'vue-router'
import router from '../../../router/index'
import { useI18n } from "vue-i18n";
import { showToast, checkSessionValidate } from "../../../utils/function";
import { current_permissions } from '../../../utils/permission';
import { Actions, Permissions, PermissionsArray, PermissionsRevokedArray, User } from "@/utils/Model";
import * as yup from 'yup';
import { useFixedDropdowns } from "@/utils/useFixedDropdowns";


export default /*@__PURE__*/_defineComponent({
  __name: 'AllUsersContent',
  setup(__props) {

const backApi = inject('back');
const selectedValidation = ref('ACTIVE');
const selectedRole = ref('');
const selectedType = ref('');
const type = ref('');
const role = ref('');
const edit = ref(0);
let itemCode = '';
const errors = ref('');  
const success = ref('');
const errorId = ref('');
const errorsBis: { [key: string]: string } = { 'name': '', 'email': '', 'password': '', 'confirm_password': '' };
const pageLoad = ref(false);
const { t } = useI18n();
let result = ref(0);    
let link = ref('');
let zonePassword = 1;
const check = ref(true);
let userCode = ref('')
let userCodeSelect = ref('')
let actionsTemp = ref<Actions[]>([]);
let allPermissions = ref<PermissionsArray[]>([]);
const permissionsArrayRevokedTemp = ref<PermissionsRevokedArray[]>([]);

const selectedPermissions = ref<string[]>([])
const selectedActions = ref([]);

let btnLoad = ref(false)
let permissionRevokedUserCode = ref('')
let permissionRevokedPermissionCode = ref('')

const permissionToRevokeCode = ref('')
const permissionToRevokeName = ref('')

let tabsPermission = ref('1')

let revoquePermissionError = ref('')

const generatedPassword = ref('');
const checkGenerated = ref(true);

const organizationName = ref('');

const searchQuery = ref('');
let searchTimeout: ReturnType<typeof setTimeout> | null = null;

// Pagination pour les utilisateurs (client-side)
const currentPage = ref(1);
const itemsPerPage = ref(10);

// Données utilisateurs
const allUsers = ref<User[]>([]);

useFixedDropdowns();

const ROLE_HIERARCHY = [
  'SUPERADMIN',
  'BUSINESS',
  'SUPPORT',
  'ADMIN',
  'USER',
  'USER_READ_ONLY'
]
const currentUserRole = localStorage.getItem('role')
const getRoleIndex = (role: string) => ROLE_HIERARCHY.indexOf(role)

const token = localStorage.getItem('login_token');
role.value = localStorage.getItem('role');

const currentRole = localStorage.getItem('role');
const isAuthorizedRole = computed(() => {
  return currentRole === 'SUPERADMIN' || currentRole === 'BUSINESS' || currentRole === 'SUPPORT';
});

const canEditRestrictedFields = computed(() => {
  return edit.value === 0 || isAuthorizedRole.value;
});

const urlUsers = computed(() => {
  if (isAuthorizedRole.value) {
    return backApi + '/secure/users/extended';
  } else {
    return backApi + '/secure/users';
  }
});

const canActOnUser = (targetRole: string) => {
  if (!targetRole) return false;
  if (currentUserRole === 'SUPERADMIN') return true;

  const currentIndex = getRoleIndex(currentUserRole);
  const targetIndex = getRoleIndex(targetRole);

  if (currentIndex === -1 || targetIndex === -1) return false;

  return targetIndex > currentIndex;
}

const filteredRoles = computed(() => {
  if (currentUserRole === 'SUPERADMIN') {
    return ROLE_HIERARCHY
  }
  const currentIndex = getRoleIndex(currentUserRole)
  if (currentIndex === -1) return []
  return ROLE_HIERARCHY.slice(currentIndex + 1)
})

// Filtrage des utilisateurs
const filteredUsers = computed(() => {
  if (!searchQuery.value || searchQuery.value.trim() === '') {
    return allUsers.value;
  }
  const query = searchQuery.value.toLowerCase().trim();
  return allUsers.value.filter(user => {
    return (
      user.name?.toLowerCase().includes(query) ||
      user.email?.toLowerCase().includes(query) ||
      user.username?.toLowerCase().includes(query) ||
      user.role?.toLowerCase().includes(query) ||
      user.type?.toLowerCase().includes(query) ||
      user.status?.toLowerCase().includes(query) ||
      user.organization?.name?.toLowerCase().includes(query) ||
      user.organization?.code?.toLowerCase().includes(query)
    );
  });
});

// Pagination des utilisateurs
const paginatedUsers = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  const end = start + itemsPerPage.value;
  return filteredUsers.value.slice(start, end);
});

const totalPages = computed(() => {
  return Math.max(1, Math.ceil(filteredUsers.value.length / itemsPerPage.value));
});

// Info pagination
const showingFrom = computed(() => {
  if (filteredUsers.value.length === 0) return 0;
  return (currentPage.value - 1) * itemsPerPage.value + 1;
});

const showingTo = computed(() => {
  const end = currentPage.value * itemsPerPage.value;
  return Math.min(end, filteredUsers.value.length);
});

const changePage = (page: number) => {
  if (page < 1 || page > totalPages.value) return;
  currentPage.value = page;
}

const debouncedSearch = () => {
  if (searchTimeout) {
    clearTimeout(searchTimeout);
  }
  searchTimeout = setTimeout(() => {
    currentPage.value = 1;
  }, 300);
};

watch(searchQuery, () => {
  currentPage.value = 1;
});

function handleValidationChange(event: Event) {
  const target = event.target as HTMLSelectElement;
  selectedValidation.value = target.value;
}

function handleRoleChange(event: Event) {
  const target = event.target as HTMLSelectElement;
  selectedRole.value = target.value;
}

function handleTypeChange(event: Event) {
  const target = event.target as HTMLSelectElement;
  selectedType.value = target.value;
  if (selectedType.value === 'WEB') {
    zonePassword = 1
  } else {
    zonePassword = 2
  }
}

const selectedTabsPermission = (event: string) => {
  getPermissionByUser(userCode.value)
  if (event === '1') {
    tabsPermission.value = '1'
  } else if (event === '2') {
    tabsPermission.value = '2'
    selectedPermissions.value = [];
    getPermissions();
  } else {
    getPermissionsRevoked(userCode.value)
    tabsPermission.value = '3'
  }
}

const openRevokeModal = (permission: Permissions) => {
  revoquePermissionError.value = ''
  formValues.revoke_reason = ''
  permissionToRevokeCode.value = permission.code
  permissionToRevokeName.value = permission.name
  const modalEl = document.getElementById('revokePermissionModal');
  const modalInstance = Modal.getOrCreateInstance(modalEl as HTMLElement);
  modalInstance.show();
}

const getOrganizationNameByCode = (orgCode: string) => {
  if (!orgCode) return ''
  const found = allUsers.value.find(u => u.organization?.code === orgCode)
  if (found?.organization?.name) return found.organization.name
  return localStorage.getItem('organization_name') || orgCode
}

const initField = () => {
  formValues.name = '';
  formValues.password = '';
  formValues.email = '';
  formValues.confirm_password = '';
  formValues.organization_code = code as string;
  organizationName.value = getOrganizationNameByCode(code as string);
  selectedValidation.value = 'ACTIVE';
  selectedRole.value = '';
  selectedType.value = '';
  itemCode = '';
  edit.value = 0;
  zonePassword = 1;
  result.value = 0;
}

function copyToCliboard() {
  const copyText = document.getElementById("link") as HTMLInputElement;
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(copyText.value);
  showToast("Copié", "green");
}

const generatePasswordForUser = (userCode: string) => {
  axios.post(`${backApi}/secure/users/generate-password`, {
    user: userCode,
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }).then((response) => {
    if (response.status === 200) {
      generatedPassword.value = response.data.plainPassword;
      checkGenerated.value = true;
      const modalEl = document.getElementById('generatePasswordModal');
      const modalInstance = Modal.getOrCreateInstance(modalEl as HTMLElement);
      modalInstance.show();
    }
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      } else {
        showToast(error.response.data.message, "red");
      }
    }
  });
}

const toggleGeneratedPassword = () => {
  const mdps = document.querySelectorAll('.mdp-generated');
  mdps.forEach(mdp => {
    if (mdp.getAttribute('type') === 'password') {
      mdp.setAttribute('type', 'text');
      checkGenerated.value = false;
    } else {
      mdp.setAttribute('type', 'password');
      checkGenerated.value = true;
    }
  });
}

const copyGeneratedPassword = () => {
  const copyText = document.getElementById("generatedPasswordInput") as HTMLInputElement;
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(copyText.value);
  showToast("Copié", "green");
}

const save = () => {
  if (currentUserRole !== 'SUPERADMIN') {
    const currentIndex = getRoleIndex(currentUserRole);
    const targetIndex = getRoleIndex(selectedRole.value);
    if (currentIndex === -1 || targetIndex === -1 || targetIndex <= currentIndex) {
      showToast("Vous ne pouvez pas attribuer ce rôle", "red");
      return;
    }
  }

  if (edit.value == 0) {
    storeUser()
  } else {
    updateUser()
  }
}

const saveAttributePermission = () => {
  errorId.value = ''
  errors.value = ''
  success.value = ''
  btnLoad.value = true
  attributePermission()
}

const formValues = reactive({
  name: "",
  email: "",
  password: "",
  confirm_password: "",
  revoke_reason: "",
  organization_code: "",
});

const schema = yup.object({
  email: yup.string().email('l\'e-mail doit être un e-mail valide').required('L\'email est requis'),
  name: yup.string().required('Le nom complet est requis'),
  password: yup.string().required('Le mot de passe est requis').min(6, 'Le mot de passe doit faire au moin 6 caractères'),
  confirm_password: yup.string().required('La confirmation du mot de passe est requis').min(6, 'La confirmation du mot de passe doit faire au moin 6 caractères').oneOf([yup.ref('password'), null], "La confirmation du mot de passe doit être identique au mot de passe")
});

const schemaTypeWEB = yup.object({
  email: yup.string().email('l\'e-mail doit être un e-mail valide').required('L\'email est requis'),
  name: yup.string().required('Le nom complet est requis'),
  password: yup.string().required('Le mot de passe est requis').min(6, 'Le mot de passe doit faire au moin 6 caractères'),
  confirm_password: yup.string().required('La confirmation du mot de passe est requis').min(6, 'La confirmation du mot de passe doit faire au moin 6 caractères').oneOf([yup.ref('password'), null], "La confirmation du mot de passe doit être identique au mot de passe")
});

const schemaTypeAPI = yup.object({
  email: yup.string().email('l\'e-mail doit être un e-mail valide').required('L\'email est requis'),
  name: yup.string().required('Le nom complet est requis'),
});

const users = ref(new Array<User>());
const permissionByUser = ref<Permissions[]>([]);

let code: string | null = '';

onMounted(() => {
  checkSessionValidate(1);
  const route = useRoute();
  code = route.params.id as string;
  
  getUsers(code);
  getActions();
  getPermissions();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000);
});


const fetchUsersPage = (organizationCode: string, targetPage: number) => {
  const baseUrl = isAuthorizedRole.value
    ? `${urlUsers.value}?organization=${organizationCode}`
    : `${urlUsers.value}`;
  const separator = baseUrl.includes('?') ? '&' : '?';
  const url = `${baseUrl}${separator}page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const getUsers = async (organizationCode: string) => {
  try {
    const first = await fetchUsersPage(organizationCode, 1);
    const collected = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchUsersPage(organizationCode, p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    allUsers.value = collected;
    users.value = collected;
    currentPage.value = 1;
    
  } catch (error: any) {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const fetchPermissionsPage = (targetPage: number) => {
  const url = `${backApi}/secure/permissions/?page=${targetPage}`;
  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const getPermissions = async () => {
  try {
    const first = await fetchPermissionsPage(1);
    const collected = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchPermissionsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    allPermissions.value = collected.sort((a, b) => {
      const nameA = a.name ? a.name.toUpperCase() : '';
      const nameB = b.name ? b.name.toUpperCase() : '';
      return nameA.localeCompare(nameB);
    });
    
    console.log(` ${allPermissions.value.length} permissions chargées`);
    
  } catch (error: any) {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const getPermissionByUser = (code: string) => {
  const target = allUsers.value.find(u => u.code === code);
  if (target && !canActOnUser(target.role)) {
    showToast("Action non autorisée sur ce rôle", "red");
    return;
  }

  errorId.value = ''
  errors.value = ''
  success.value = ''
  tabsPermission.value = '1'
  userCode.value = code
  userCodeSelect.value = code

  axios.get(`${backApi}/secure/permissions/user/${code}/show`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    permissionByUser.value = response.data.allPermissions || [];
  })
  .catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });

  getPermissionsRevoked(userCode.value)
}

const showUser = (userCodeToEdit: string) => {
  const target = allUsers.value.find(u => u.code === userCodeToEdit);
  if (target && !canActOnUser(target.role)) {
    showToast("Action non autorisée sur ce rôle", "red");
    return;
  }

  axios.get(`${backApi}/secure/users/${userCodeToEdit}/show`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      formValues.name = response.data.name;
      formValues.email = response.data.email;
      formValues.organization_code = response.data.organization?.code ?? code as string;
      organizationName.value = response.data.organization?.name ?? getOrganizationNameByCode(formValues.organization_code);
      selectedValidation.value = response.data.status;
      selectedRole.value = response.data.role;
      selectedType.value = response.data.type;
      zonePassword = response.data.type === 'API' ? 2 : 1;
      itemCode = response.data.code;
      edit.value = 1;
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const togglePassword = () => {
  const mdps = document.querySelectorAll('.mdp');
  mdps.forEach(mdp => {
    if (mdp.getAttribute('type') === 'password') {
      mdp.setAttribute('type', 'text');
      check.value = false;
    } else {
      mdp.setAttribute('type', 'password');
      check.value = true;
    }
  });
}

const storeUser = () => {
  try {
    if (selectedRole.value == '') {
      showToast("Veuillez sélectionner un rôle", "red");
      return;
    }
    if (selectedValidation.value == '') {
      showToast("Veuillez sélectionner un statut", "red");
      return;
    }
    if (selectedType.value == '') {
      showToast("Veuillez sélectionner un type", "red");
      return;
    }

    const payloadStoreUserWEB = {
      name: formValues.name,
      role: selectedRole.value,
      status: selectedValidation.value,
      email: formValues.email,
      password: formValues.password,
      organization: formValues.organization_code,
      type: selectedType.value,
    }

    const payloadStoreUserAPI = {
      name: formValues.name,
      role: selectedRole.value,
      status: selectedValidation.value,
      password: null,
      email: formValues.email,
      organization: formValues.organization_code,
      type: selectedType.value,
    }

    let payload = {}
    if (zonePassword == 1) {
      schemaTypeWEB.validateSync(formValues);
      payload = payloadStoreUserWEB
    } else {
      schemaTypeAPI.validateSync(formValues);
      payload = payloadStoreUserAPI
    }

    axios.post(`${backApi}/secure/users/new`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Utilisateur enregistré avec succès", "green");

        const modalEl = document.getElementById('companyModal');
        const modalInstance = Modal.getInstance(modalEl) || Modal.getOrCreateInstance(modalEl);
        modalInstance.hide();

        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');

        setTimeout(() => {
          router.go();
        }, 500);
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    console.error(error);
    errors.value = "une erreur inattendue est apparue"
  }
}

const attributePermission = () => {
  try {
    const payload = {
      user: userCodeSelect.value,
      permission: selectedPermissions.value,
      organization: null,
    }

    axios.post(`${backApi}/secure/permissions/grant`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        showToast("Permission attribué avec succès", "green");
        btnLoad.value = false
        setTimeout(() => {
          zonePassword = 0
          router.go();
        }, 500);
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
          btnLoad.value = false
        }
        btnLoad.value = false
      }
    });
  } catch (error) {
    console.error(error);
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = false
  }
}

const updateUser = () => {
  try {
    if (zonePassword == 1) {
      schemaTypeWEB.validateSync(formValues);
    } else {
      schemaTypeAPI.validateSync(formValues);
    }
    axios.put(`${backApi}/secure/users/${itemCode}/edit`, {
      name: formValues.name,
      role: selectedRole.value,
      status: selectedValidation.value,
      email: formValues.email,
      password: formValues.password,
      organization: formValues.organization_code,
      code: itemCode,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
        if (response.status === 200) {
          showToast("Utilisaeur modifié avec succès", "green");

          const modalEl = document.getElementById('companyModal');
          const modalInstance = Modal.getInstance(modalEl) || Modal.getOrCreateInstance(modalEl);
          modalInstance.hide();

          document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
          document.body.classList.remove('modal-open');
          document.body.style.removeProperty('overflow');
          document.body.style.removeProperty('padding-right');

          setTimeout(() => {
            router.go();
          }, 500);
        }
      }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    console.error(error);
    errors.value = "une erreur inattendue est apparue"
  }
}

function validate(field: string) {
  if (zonePassword === 2 && (field === 'password' || field === 'confirm_password')) {
    errorsBis[field] = "";
    return;
  }

  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch((err: yup.ValidationError) => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

const getActions = () => {
  const baseUrl = backApi + '/secure/actions/';
  
  axios.get(`${baseUrl}?page=1&limit=1000`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    actionsTemp.value = (response.data.data || []).sort((a, b) => {
      const routeA = a.route ? a.route.toUpperCase() : '';
      const routeB = b.route ? b.route.toUpperCase() : '';
      return routeA.localeCompare(routeB);
    });
  })
  .catch((error) => {
    if (error.response?.status === 401) {
      router.push('/');
    }
  });
}

const hasPermission = (permissionCode: string) => {
  return permissionByUser.value.some(p => p.code === permissionCode);
};

const getPermissionsRevoked = (user: string) => {
  axios.get(`${backApi}/secure/permissions/revoked/?user=${user}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    const data = response.data;
    const arrayData = Array.isArray(data) ? data : [data];
    permissionsArrayRevokedTemp.value = arrayData.filter(
      (item) => item.disabledAt === null
    );
  })
  .catch((error) => {
    if (error.response?.status === 401) {
      router.push('/');
    }
  });
}

const changeStatus = (status: string, code: string) => {
  const target = allUsers.value.find(u => u.code === code);
  if (target && !canActOnUser(target.role)) {
    showToast("Action non autorisée sur ce rôle", "red");
    return;
  }

  axios.post(`${backApi}/secure/users/activate`, {
    code: code,
    status: (status == 'ACTIVE') ? 'INACTIVE' : 'ACTIVE'
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    router.go();
  }).catch((error) => {
    if (error.response) {
      showToast(error.response.data.message, "red");
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const revoquePermission = (code: string, user: string) => {
  revoquePermissionError.value = ""
  axios.put(`${backApi}/secure/permissions/${code}/revoke`, {
    permission: code,
    organization: null,
    user: user,
    reason: formValues.revoke_reason
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    showToast("Opération réussie", "green");
    const modalEl = document.getElementById('revokePermissionModal');
    const modalInstance = Modal.getOrCreateInstance(modalEl as HTMLElement);
    modalInstance.hide();
    setTimeout(() => {
      router.go();
    }, 500);
  }).catch((error) => {
    if (error.response) {
      revoquePermissionError.value = error.response.data.message;
      showToast(error.response.data.message, "red");
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const restorePermission = (user: string, permission: string) => {
  axios.put(`${backApi}/secure/permissions/${permission}/restore`, {
    permission: permission,
    organization: null,
    user: user
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    showToast("Opération réussie", "green");
    permissionRevokedUserCode.value = ''
    permissionRevokedPermissionCode.value = ''
    setTimeout(() => {
      router.go();
    }, 500);
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        // router.push('/')
      }
      showToast(error.response.data.message, "red");
    }
  });
}

const showConfirmRestorePermission = (user: string, permission: string) => {
  permissionRevokedUserCode.value = user
  permissionRevokedPermissionCode.value = permission
}

const activeValidation = (isPayoutValidator: boolean, code: string) => {
  const target = allUsers.value.find(u => u.code === code);
  if (target && !canActOnUser(target.role)) {
    showToast("Action non autorisée sur ce rôle", "red");
    return;
  }

  axios.post(`${backApi}/secure/users/payout-validator`, {
    code: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    showToast("Opération réussie", "green");
    setTimeout(() => {
      router.go();
    }, 500);
  }).catch((error) => {
    if (error.response) {
      showToast(error.response.data.message, "red");
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[27] || (_cache[27] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_unref(current_permissions)('create_user', 'edit_user'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#companyModal",
                    style: {"background-color":"#EB9355","justify-content":"center"},
                    onClick: initField
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('users.createUser')) + " ", 1),
                    _cache[28] || (_cache[28] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                type: "text",
                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                placeholder: _ctx.$t('users.search') || 'Rechercher...',
                onInput: debouncedSearch
              }, null, 40, _hoisted_6), [
                [_vModelText, searchQuery.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('users.id')), 1),
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('users.name')), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('users.username')), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('users.email')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('users.role')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('users.type')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('users.status')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('users.validator')), 1),
                    _cache[29] || (_cache[29] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedUsers.value, (user) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: user.code
                    }, [
                      _createElementVNode("th", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "form-check mb-0" }, [
                            _createElementVNode("input", {
                              class: "form-check-input shadow-none",
                              type: "checkbox"
                            })
                          ], -1)),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(user.code), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(user.name), 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(user.username), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(user.email), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(user.role), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(user.type), 1),
                      _createElementVNode("td", _hoisted_26, [
                        (user.status==='ACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('users.active')), 1))
                          : _createCommentVNode("", true),
                        (user.status==='INACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('users.inactive')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_29, [
                        (user.isPayoutValidator===true)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t('users.yes')), 1))
                          : _createCommentVNode("", true),
                        (user.isPayoutValidator===false)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('users.no')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_32, [
                        (canActOnUser(user.role))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _cache[36] || (_cache[36] = _createElementVNode("button", {
                                class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                type: "button",
                                "data-bs-toggle": "dropdown",
                                "aria-expanded": "false"
                              }, [
                                _createElementVNode("i", { class: "flaticon-dots" })
                              ], -1)),
                              _createElementVNode("ul", _hoisted_34, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#companyModal",
                                    onClick: ($event: any) => (showUser(user.code))
                                  }, [
                                    _cache[31] || (_cache[31] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('users.edit')), 1)
                                  ], 8, _hoisted_35)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (activeValidation(user.isPayoutValidator,user.code))
                                  }, [
                                    _cache[32] || (_cache[32] = _createElementVNode("i", { class: "flaticon-logout lh-1 me-8 position-relative top-1" }, null, -1)),
                                    (user.isPayoutValidator===false)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t('users.activateValidator')), 1))
                                      : _createCommentVNode("", true),
                                    (user.isPayoutValidator===true)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t('users.deactivateValidator')), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_36)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (changeStatus(user.status,user.code))
                                  }, [
                                    _cache[33] || (_cache[33] = _createElementVNode("i", { class: "flaticon-logout lh-1 me-8 position-relative top-1" }, null, -1)),
                                    (user.status==='ACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.$t('users.deactivate')), 1))
                                      : _createCommentVNode("", true),
                                    (user.status==='INACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$t('users.activate')), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_39)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (getPermissionByUser(user.code))
                                  }, [
                                    _createElementVNode("span", _hoisted_43, [
                                      _cache[34] || (_cache[34] = _createElementVNode("i", { class: "flaticon-logout lh-1 me-8 position-relative top-1" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('users.permission')), 1)
                                    ])
                                  ], 8, _hoisted_42)
                                ]),
                                (user.type === 'API')
                                  ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item d-flex align-items-center",
                                        href: "javascript:void(0);",
                                        onClick: ($event: any) => (generatePasswordForUser(user.code))
                                      }, [
                                        _cache[35] || (_cache[35] = _createElementVNode("i", { class: "flaticon-logout lh-1 me-8 position-relative top-1" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('users.generatePassword')), 1)
                                      ], 8, _hoisted_45)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            (filteredUsers.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  (filteredUsers.value.length > itemsPerPage.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_48, [
                        _createTextVNode(_toDisplayString(_ctx.$t('users.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_49, _toDisplayString(showingFrom.value) + "-" + _toDisplayString(showingTo.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('users.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_50, _toDisplayString(filteredUsers.value.length), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('users.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (filteredUsers.value.length <= itemsPerPage.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_51, [
                        _createTextVNode(_toDisplayString(_ctx.$t('users.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_52, _toDisplayString(filteredUsers.value.length), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('users.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_53, _toDisplayString(filteredUsers.value.length), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('users.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_54, [
                    _createElementVNode("ul", _hoisted_55, [
                      ((currentPage.value-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_56, [
                            _createElementVNode("a", {
                              class: "page-link",
                              href: "#",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (changePage(currentPage.value-1)), ["prevent"])),
                              "aria-label": "Previous"
                            }, [...(_cache[37] || (_cache[37] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==currentPage.value)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_57, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                href: "#",
                                onClick: _withModifiers(($event: any) => (changePage(numPage)), ["prevent"])
                              }, _toDisplayString(numPage), 9, _hoisted_58))
                        ]))
                      }), 128)),
                      ((currentPage.value+1)<=totalPages.value)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_59, [
                            _createElementVNode("a", {
                              class: "page-link",
                              href: "#",
                              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (changePage(currentPage.value+1)), ["prevent"])),
                              "aria-label": "Next"
                            }, [...(_cache[38] || (_cache[38] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("h5", _hoisted_62, _toDisplayString(_ctx.$t('users.permissionManagement')), 1),
        _cache[39] || (_cache[39] = _createElementVNode("button", {
          type: "button",
          class: "btn-close",
          "data-bs-dismiss": "offcanvas",
          "aria-label": "Close"
        }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("ul", _hoisted_64, [
          _createElementVNode("li", _hoisted_65, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link", { active: _unref(tabsPermission) === '1' }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (selectedTabsPermission('1'))),
              href: "javascript:void(0)"
            }, _toDisplayString(_ctx.$t('users.list')), 3)
          ]),
          _createElementVNode("li", _hoisted_66, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link", { active: _unref(tabsPermission) === '2' }]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (selectedTabsPermission('2'))),
              href: "javascript:void(0)"
            }, _toDisplayString(_ctx.$t('users.assign')), 3)
          ]),
          _createElementVNode("li", _hoisted_67, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link", { active: _unref(tabsPermission) === '3' }]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (selectedTabsPermission('3'))),
              href: "javascript:void(0)"
            }, _toDisplayString(_ctx.$t('users.restore')), 3)
          ])
        ]),
        (_unref(tabsPermission) === '1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
              (permissionByUser.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(_ctx.$t('users.no')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissionByUser.value, (permission) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: permission.code,
                  class: "permission-row d-flex align-items-center justify-content-between gap-10 py-12 px-10 mb-8 rounded-2"
                }, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, _toDisplayString(permission.name), 1),
                    _createElementVNode("div", _hoisted_72, _toDisplayString(permission.code), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-danger flex-shrink-0",
                    onClick: ($event: any) => (openRevokeModal(permission))
                  }, _toDisplayString(_ctx.$t('users.revoke')), 9, _hoisted_73)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_unref(tabsPermission) === '2')
          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
              _createElementVNode("form", {
                onSubmit: _withModifiers(saveAttributePermission, ["prevent"]),
                class: "d-flex flex-column flex-grow-1"
              }, [
                (errors.value!=='')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      _createElementVNode("h6", _hoisted_76, _toDisplayString(errorId.value), 1),
                      _createElementVNode("h6", _hoisted_77, _toDisplayString(errors.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                (success.value!=='')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _createElementVNode("h6", _hoisted_79, _toDisplayString(success.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t('users.availablePermissions')), 1),
                _createElementVNode("div", _hoisted_81, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allPermissions), (permission) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: permission.code,
                      class: "form-check col-12 col-sm-6 col-lg-4"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: 'permission-' + permission.code,
                        value: permission.code,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedPermissions).value = $event)),
                        disabled: hasPermission(permission.code)
                      }, null, 8, _hoisted_82), [
                        [_vModelCheckbox, selectedPermissions.value]
                      ]),
                      _createElementVNode("label", {
                        class: "form-check-label text-black",
                        for: 'permission-' + permission.code
                      }, _toDisplayString(permission.name), 9, _hoisted_83)
                    ]))
                  }), 128))
                ]),
                (_unref(current_permissions)('grant_permission'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "submit",
                      class: "btn text-white w-100 mt-auto",
                      style: {"background-color":"#EB9355"},
                      disabled: _unref(btnLoad)
                    }, [
                      (_unref(btnLoad))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_85))
                        : _createCommentVNode("", true),
                      (!_unref(btnLoad))
                        ? (_openBlock(), _createElementBlock("i", _hoisted_86))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('users.save')), 1)
                    ], 8, _hoisted_84))
                  : _createCommentVNode("", true)
              ], 32)
            ]))
          : _createCommentVNode("", true),
        (_unref(tabsPermission) === '3')
          ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
              (permissionsArrayRevokedTemp.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_88, _toDisplayString(_ctx.$t('users.no')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissionsArrayRevokedTemp.value, (permissionRevoked) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: permissionRevoked.permission?.code,
                  class: "permission-row d-flex align-items-center justify-content-between gap-10 py-12 px-10 mb-8 rounded-2"
                }, [
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, _toDisplayString(permissionRevoked.permission?.name || 'N/A'), 1),
                    _createElementVNode("div", _hoisted_91, _toDisplayString(permissionRevoked.reason), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-success flex-shrink-0",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#staticBackdrop",
                    onClick: ($event: any) => (showConfirmRestorePermission(permissionRevoked.user?.code, permissionRevoked.permission?.code))
                  }, _toDisplayString(_ctx.$t('users.restore')), 9, _hoisted_92)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_93, [
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("h1", _hoisted_97, _toDisplayString(_ctx.$t('users.revoke')), 1),
            _cache[40] || (_cache[40] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("p", _hoisted_99, _toDisplayString(permissionToRevokeName.value), 1),
            _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t('users.revokeReason')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formValues.revoke_reason) = $event)),
              type: "text",
              class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
              placeholder: _ctx.$t('users.revokeReason')
            }, null, 8, _hoisted_101), [
              [_vModelText, formValues.revoke_reason]
            ]),
            (_unref(revoquePermissionError))
              ? (_openBlock(), _createElementBlock("div", _hoisted_102, _toDisplayString(_unref(revoquePermissionError)), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("button", _hoisted_104, _toDisplayString(_ctx.$t('users.no')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn text-white",
              style: {"background-color":"#EB9355"},
              onClick: _cache[8] || (_cache[8] = ($event: any) => (revoquePermission(permissionToRevokeCode.value, _unref(userCode))))
            }, _toDisplayString(_ctx.$t('users.yes')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_105, [
      _createElementVNode("div", _hoisted_106, [
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(save, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("h1", _hoisted_109, _toDisplayString(edit.value == 0 ? _ctx.$t('users.create') : _ctx.$t('users.edit')) + " " + _toDisplayString(_ctx.$t('users.user')), 1),
              _cache[41] || (_cache[41] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_110, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                    _createElementVNode("h6", _hoisted_112, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_113, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                    _createElementVNode("h6", _hoisted_115, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("div", _hoisted_117, [
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.$t('users.fullName')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formValues.name) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                        placeholder: _ctx.$t('users.fullNamePlaceholder'),
                        onBlur: _cache[10] || (_cache[10] = ($event: any) => (validate('name'))),
                        onKeyup: _cache[11] || (_cache[11] = ($event: any) => (validate('name'))),
                        readonly: !canEditRestrictedFields.value
                      }, null, 42, _hoisted_120), [
                        [_vModelText, formValues.name]
                      ]),
                      _createElementVNode("span", _hoisted_121, _toDisplayString(errorsBis['name']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_122, [
                    _createElementVNode("label", _hoisted_123, _toDisplayString(_ctx.$t('users.email')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formValues.email) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['email'] }]),
                        placeholder: _ctx.$t('users.emailPlaceholder'),
                        onBlur: _cache[13] || (_cache[13] = ($event: any) => (validate('email'))),
                        onKeyup: _cache[14] || (_cache[14] = ($event: any) => (validate('email'))),
                        readonly: !canEditRestrictedFields.value
                      }, null, 42, _hoisted_124), [
                        [_vModelText, formValues.email]
                      ]),
                      _createElementVNode("span", _hoisted_125, _toDisplayString(errorsBis['email']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("div", _hoisted_127, [
                    _createElementVNode("label", _hoisted_128, _toDisplayString(_ctx.$t('users.type')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("select", {
                        name: "type",
                        id: "type",
                        class: "form-select fs-md-15 text-black shadow-none",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedType).value = $event)),
                        onChange: handleTypeChange,
                        disabled: !canEditRestrictedFields.value,
                        required: ""
                      }, [
                        _createElementVNode("option", _hoisted_130, _toDisplayString(_ctx.$t('users.select')), 1),
                        _cache[42] || (_cache[42] = _createElementVNode("option", { value: "WEB" }, "WEB", -1)),
                        _cache[43] || (_cache[43] = _createElementVNode("option", { value: "API" }, "API", -1))
                      ], 40, _hoisted_129), [
                        [_vModelSelect, selectedType.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.$t('users.role')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("select", {
                        name: "role",
                        id: "role",
                        class: "form-select fs-md-15 text-black shadow-none",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((selectedRole).value = $event)),
                        onChange: handleRoleChange,
                        disabled: !canEditRestrictedFields.value,
                        required: ""
                      }, [
                        _createElementVNode("option", _hoisted_134, _toDisplayString(_ctx.$t('users.select')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRoles.value, (roleItem) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: roleItem,
                            value: roleItem
                          }, _toDisplayString(roleItem), 9, _hoisted_135))
                        }), 128))
                      ], 40, _hoisted_133), [
                        [_vModelSelect, selectedRole.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("label", _hoisted_137, _toDisplayString(_ctx.$t('users.status')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("select", {
                        name: "status",
                        id: "status",
                        class: "form-select fs-md-15 text-black shadow-none",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((selectedValidation).value = $event)),
                        onChange: handleValidationChange,
                        required: ""
                      }, [
                        _createElementVNode("option", _hoisted_138, _toDisplayString(_ctx.$t('users.inactive')), 1),
                        _createElementVNode("option", _hoisted_139, _toDisplayString(_ctx.$t('users.active')), 1)
                      ], 544), [
                        [_vModelSelect, selectedValidation.value]
                      ])
                    ])
                  ])
                ]),
                (_unref(zonePassword)==1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                      _createElementVNode("div", _hoisted_141, [
                        _createElementVNode("label", _hoisted_142, _toDisplayString(_ctx.$t('users.password')), 1),
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formValues.password) = $event)),
                            type: "password",
                            class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['password'] }]),
                            placeholder: "***********",
                            onBlur: _cache[19] || (_cache[19] = ($event: any) => (validate('password'))),
                            onKeyup: _cache[20] || (_cache[20] = ($event: any) => (validate('password')))
                          }, null, 34), [
                            [_vModelText, formValues.password]
                          ]),
                          _createElementVNode("span", _hoisted_143, _toDisplayString(errorsBis['password']), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_144, [
                        _createElementVNode("label", _hoisted_145, _toDisplayString(_ctx.$t('users.confirmPassword')), 1),
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formValues.confirm_password) = $event)),
                            type: "password",
                            class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['confirm_password'] }]),
                            placeholder: "***********",
                            onBlur: _cache[22] || (_cache[22] = ($event: any) => (validate('confirm_password'))),
                            onKeyup: _cache[23] || (_cache[23] = ($event: any) => (validate('confirm_password')))
                          }, null, 34), [
                            [_vModelText, formValues.confirm_password]
                          ]),
                          _createElementVNode("span", _hoisted_146, _toDisplayString(errorsBis['confirm_password']), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(zonePassword)==2 && edit.value==0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                      (_unref(result)==1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                            _createElementVNode("label", _hoisted_149, _toDisplayString(_ctx.$t('users.password')), 1),
                            _createElementVNode("div", _hoisted_150, [
                              _withDirectives(_createElementVNode("input", {
                                type: "password",
                                class: "col fw-medium text-black fs-md-15 fs-lg-16 mdp text-center border-0",
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_isRef(link) ? (link).value = $event : link = $event)),
                                id: "link",
                                readonly: ""
                              }, null, 512), [
                                [_vModelText, _unref(link)]
                              ]),
                              _createElementVNode("div", _hoisted_151, [
                                (check.value)
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 0,
                                      class: "flaticon-view",
                                      id: "togglePassword",
                                      onClick: togglePassword
                                    }))
                                  : _createCommentVNode("", true),
                                (!check.value)
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 1,
                                      class: "flaticon-eye-1",
                                      id: "togglePassword",
                                      onClick: togglePassword
                                    }))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(result)==1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                            _createElementVNode("a", {
                              href: "#",
                              class: "text-decoration-none d-block text-center",
                              onClick: copyToCliboard
                            }, [...(_cache[44] || (_cache[44] = [
                              _createElementVNode("i", {
                                class: "flaticon-draft fs-6",
                                style: {"color":"#000"}
                              }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_153, [
              (_unref(current_permissions)('create_user', 'edit_user'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_154, [
                    _cache[45] || (_cache[45] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('users.save')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_155, [
      _createElementVNode("div", _hoisted_156, [
        _createElementVNode("div", _hoisted_157, [
          _cache[46] || (_cache[46] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: "staticBackdropLabel"
            }),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_158, [
            _createElementVNode("h4", _hoisted_159, _toDisplayString(_ctx.$t('users.confirmRestore')), 1)
          ]),
          _createElementVNode("div", _hoisted_160, [
            _createElementVNode("button", _hoisted_161, _toDisplayString(_ctx.$t('users.no')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-none text-white",
              style: {"background-color":"#EB9355"},
              onClick: _cache[25] || (_cache[25] = ($event: any) => (restorePermission(_unref(permissionRevokedUserCode),_unref(permissionRevokedPermissionCode))))
            }, _toDisplayString(_ctx.$t('users.yes')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_162, [
      _createElementVNode("div", _hoisted_163, [
        _createElementVNode("div", _hoisted_164, [
          _createElementVNode("div", _hoisted_165, [
            _createElementVNode("h1", _hoisted_166, _toDisplayString(_ctx.$t('users.generatedPassword')), 1),
            _cache[47] || (_cache[47] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_167, [
            _createElementVNode("label", _hoisted_168, _toDisplayString(_ctx.$t('users.password')), 1),
            _createElementVNode("div", _hoisted_169, [
              _withDirectives(_createElementVNode("input", {
                type: "password",
                class: "col fw-medium text-black fs-md-15 fs-lg-16 mdp-generated text-center border-0",
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((generatedPassword).value = $event)),
                id: "generatedPasswordInput",
                readonly: ""
              }, null, 512), [
                [_vModelText, generatedPassword.value]
              ]),
              _createElementVNode("div", _hoisted_170, [
                (checkGenerated.value)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "flaticon-view",
                      id: "toggleGeneratedPassword",
                      onClick: toggleGeneratedPassword
                    }))
                  : _createCommentVNode("", true),
                (!checkGenerated.value)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 1,
                      class: "flaticon-eye-1",
                      id: "toggleGeneratedPassword",
                      onClick: toggleGeneratedPassword
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_171, [
            _createElementVNode("button", {
              type: "button",
              class: "btn text-white w-100 w-sm-auto",
              style: {"background-color":"#EB9355"},
              onClick: copyGeneratedPassword
            }, [
              _cache[48] || (_cache[48] = _createElementVNode("i", {
                class: "flaticon-draft fs-6 me-5",
                style: {"color":"#FFF"}
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('users.copyPaste')), 1)
            ])
          ])
        ])
      ])
    ]),
    _cache[49] || (_cache[49] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})